export const snapshotManagementTasksMessages = {
  en: {
    actionColumnTitle: 'Action',
    btnShowLog: 'CLI output',
    btnErrors: 'Errors',
    btnBack: 'Back',
    btnExclude: 'Exclude from discovery',
    btnRediscover: 'Rediscover',
    errorDetailModalTitle: 'Error detail: {ip}',
    errorDetail: {
      title: 'Error detail',
      columns: {
        errType: 'Error Type',
        msg: 'Error',
        source: 'Source',
        ts: 'Datetime',
      },
    },
    rediscoverDialog: {
      header: 'Selected devices will be rediscovered',
      subHeader: 'Are you sure to rediscover selected devices?',
      btnSecondaryConfirm: 'Cancel',
      btnConfirm: 'Rediscover',
    },
    excludeDialog: {
      header: 'Exclude from discovery?',
      subHeader:
        'If confirmed, the selected IPs will be added to the Exclude list in the Discovery settings and will be excluded from all future discoveries and analysis.',
      btnSecondaryConfirm: 'Cancel',
      btnConfirm: 'Exclude from discovery',
    },
    excludeSuccess:
      'Selected IPs were added to the Exclude list in the Discovery settings.',
  },
};
